import Vue from "vue";
import VueRouter from "vue-router";

import Dashboard from "@/views/dashboards/Dashboard.vue";
// import GraficosAdministradores from "@/views/graficos/GraficosAdministradores.vue";
// import GraficosFornecedores from "@/views/graficos/GraficosFornecedores.vue";
// import GraficosRepresentantes from "@/views/graficos/GraficosRepresentantes.vue";
// import RelatoriosAdministradores from "@/views/relatorios/RelatoriosAdministradores.vue";
// import RelatoriosFornecedores from "@/views/relatorios/RelatoriosFornecedores.vue";
// import RelatoriosRepresentantes from "@/views/relatorios/RelatoriosRepresentantes.vue";
import Clientes from "@/views/clientes/Clientes.vue";
import ClientesForm from "@/views/clientes/ClientesForm.vue";
import AlterarSenha from "@/views/AlterarSenha.vue";
import AlterarLogo from "@/views/AlterarLogo.vue";
import MinhaContaCliente from "@/views/clientes/MinhaContaCliente.vue";
import Fornecedores from "@/views/fornecedores/Fornecedores.vue";
import FornecedoresForm from "@/views/fornecedores/FornecedoresForm.vue";
import MinhaContaFornecedores from "@/views/fornecedores/MinhaContaFornecedores.vue";
import EntregasLista from "@/views/EntregasLista.vue";
import EntregasForm from "@/views/EntregasForm.vue";
import AdministradoresLista from "@/views/administradores/AdministradoresLista.vue";
import AdministradoresForm from "@/views/administradores/AdministradoresForm.vue";
import MinhaContaAdministrador from "@/views/administradores/MinhaContaAdministrador.vue";
import RodadasLista from "@/views/rodadas/RodadasLista.vue";
import RodadasForm from "@/views/rodadas/RodadasForm.vue";
import Stands from "@/views/rodadas/Stands.vue";
import StandsForm from "@/views/rodadas/StandsForm.vue";
import FornecedoresSelecao from "@/views/rodadas/FornecedoresSelecao.vue";
import ClientesSelecao from "@/views/rodadas/ClientesSelecao.vue";
import RepresentantesSelecao from "@/views/rodadas/RepresentantesSelecao.vue";
import Empresas from "@/views/Empresas.vue";
import EmpresasForm from "@/views/EmpresasForm.vue";
import Representantes from "@/views/representantes/Representantes.vue";
import RepresentantesForm from "@/views/representantes/RepresentantesForm.vue";
import RemessasLista from "@/views/remessas/RemessasLista.vue";
import RemessasForm from "@/views/remessas/RemessasForm.vue";
import MinhaContaRepresentante from "@/views/representantes/MinhaContaRepresentante.vue";
import FaturamentoLista from "@/views/FaturamentoLista.vue";
import FaturamentoForm from "@/views/FaturamentoForm.vue";
import ProdutosLista from "@/views/produtos/ProdutosLista.vue";
import ProdutosCadastro from "@/views/produtos/ProdutosCadastro.vue";
import PedidosLista from "@/views/pedidos/PedidosLista.vue";
import PedidosForm from "@/views/pedidos/PedidosForm.vue";
import Relatorios from "@/views/Relatorios.vue";
import Videos from "@/views/Videos.vue";
import Loja from "@/views/loja/Loja.vue";
import Notificacoes from "@/views/Notificacoes.vue";
import Checkout from "@/views/loja/Checkout.vue";
import Banners from "@/views/Banners.vue";
import BannersForm from "@/views/BannersForm.vue";
import Galeria from "@/views/produtos/Galeria";
import PedidosRedirect from "@/views/pedidos/PedidosRedirect";
import ComissoesLista from "@/views/comissoes/ComissoesLista";
import ComissoesForm from "@/views/comissoes/ComissoesForm";
import ShowRoomRodada from "@/views/loja/ShowRoomRodada.vue";
import Usuarios from "@/views/usuarios/Usuarios.vue";
import Agenda from "@/views/virtual/Agenda.vue";
import Impressoes from "@/views/Impressoes.vue";
import MapaStands from "@/views/MapaStands.vue";

import cookies from "@/util/cookies";

Vue.use(VueRouter);

const routes = [
  {
    path: "/relatorios",
    name: "relatorios",
    component: Relatorios,
    meta: {
      requiresAuth: true,
      acesso: ["administrador", "fornecedor", "representante"],
    },
  },
  /* {
    path: '/relatorios-administradores',
    name: 'relatorios-administradores',
    component: RelatoriosAdministradores,
    meta: { requiresAuth: true, acesso: ['master', 'administrador'] }
  },
  {
    path: '/relatorios-fornecedores',
    name: 'relatorios-fornecedores',
    component: RelatoriosFornecedores,
    meta: { requiresAuth: true, acesso: ['master', 'fornecedor'] }
  },
  {
    path: '/relatorios-representantes',
    name: 'relatorios-representantes',
    component: RelatoriosRepresentantes,
    meta: { requiresAuth: true, acesso: ['master', 'representante'] }
  }, */
  {
    path: "/checkout",
    name: "checkout",
    component: Checkout,
    meta: {
      requiresAuth: true,
      acesso: ["cliente", "representante", "fornecedor"],
    },
  },
  {
    path: "/alterar-senha",
    name: "alterar-senha",
    component: AlterarSenha,
    meta: {
      requiresAuth: true,
      acesso: [
        "master",
        "administrador",
        "fornecedor",
        "representante",
        "cliente",
      ],
    },
  },
  {
    path: "/alterar-logo",
    name: "alterar-logo",
    component: AlterarLogo,
    meta: { requiresAuth: true, acesso: ["fornecedor"] },
  },
  {
    path: "/notificacoes",
    name: "notificacoes",
    component: Notificacoes,
    meta: {
      requiresAuth: true,
      acesso: [
        "master",
        "administrador",
        "fornecedor",
        "representante",
        "cliente",
      ],
    },
  },
  {
    path: "/banners",
    name: "banners",
    component: Banners,
    meta: { requiresAuth: true, acesso: ["master"] },
  },
  {
    path: "/banners/adicionar",
    name: "banners-adicionar",
    component: BannersForm,
    meta: { requiresAuth: true, acesso: ["master"] },
  },
  {
    path: "/banners/:banner_id/editar",
    name: "banners-editar",
    component: BannersForm,
    meta: { requiresAuth: true, acesso: ["master"] },
  },
  {
    path: "/clientes",
    name: "clientes",
    component: Clientes,
    meta: {
      requiresAuth: true,
      acesso: [
        "master",
        "administrador",
        "fornecedor",
        "representante",
        "cliente",
      ],
    },
  },
  {
    path: "/clientes/adicionar",
    name: "clientes-adicionar",
    component: ClientesForm,
    meta: {
      requiresAuth: true,
      acesso: ["administrador", "representante", "fornecedor"],
    },
  },
  {
    path: "/clientes/:cliente_id/editar",
    name: "clientes-editar",
    component: ClientesForm,
    meta: {
      requiresAuth: true,
      acesso: ["administrador", "representante", "master", "fornecedor"],
    },
  },
  {
    path: "/fornecedores",
    name: "fornecedores",
    component: Fornecedores,
    meta: {
      requiresAuth: true,
      acesso: ["representante", "administrador", "master"],
    },
  },
  {
    path: "/fornecedores/adicionar",
    name: "fornecedores-adicionar",
    component: FornecedoresForm,
    meta: { requiresAuth: true, acesso: ["representante", "administrador"] },
  },
  {
    path: "/fornecedores/:fornecedor_id/editar",
    name: "fornecedores-editar",
    component: FornecedoresForm,
    meta: {
      requiresAuth: true,
      acesso: ["representante", "administrador", "master"],
    },
  },
  {
    path: "/representantes/entregas",
    name: "entregas",
    component: EntregasLista,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/entregas/adicionar",
    name: "entregas-adicionar",
    component: EntregasForm,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/administradores",
    name: "administradores",
    component: AdministradoresLista,
    meta: { requiresAuth: true, acesso: ["master"] },
  },
  {
    path: "/administradores/adicionar",
    name: "administradores-adicionar",
    component: AdministradoresForm,
    meta: { requiresAuth: true, acesso: ["master"] },
  },
  {
    path: "/administrador/minha-conta",
    name: "administrador-minha-conta",
    component: MinhaContaAdministrador,
    meta: { requiresAuth: true, acesso: ["administrador"] },
  },
  {
    path: "/administradores/:administrador_id/editar",
    name: "administradores-editar",
    component: AdministradoresForm,
    meta: { requiresAuth: true, acesso: ["master"] },
  },
  {
    path: "/rodadas",
    name: "rodadas",
    component: RodadasLista,
    meta: {
      requiresAuth: true,
      acesso: [
        "master",
        "administrador",
        "representante",
        "fornecedor",
        "cliente",
      ],
    },
  },
  {
    path: "/rodadas/adicionar",
    name: "rodadas-adicionar",
    component: RodadasForm,
    meta: { requiresAuth: true, acesso: ["master"] },
  },
  {
    path: "/rodadas/:id/editar",
    name: "rodadas-editar",
    component: RodadasForm,
    meta: { requiresAuth: true, acesso: ["master", "administrador"] },
  },
  {
    path: "/rodadas/:rodada_id/stands/adicionar",
    name: "stands-adicionar",
    component: StandsForm,
    meta: { requiresAuth: true, acesso: ["administrador"] },
  },

  {
    path: "/rodadas/:rodada_id/stands/:stand_id/editar",
    name: "stands-editar",
    component: StandsForm,
    meta: { requiresAuth: true, acesso: ["administrador"] },
  },
  {
    path: "/rodadas/:rodada_id/stands",
    name: "stands",
    component: Stands,
    meta: { requiresAuth: true, acesso: ["administrador"] },
  },
  {
    path: "/rodadas/:rodada_id/fornecedores",
    name: "rodadas-fornecedores",
    component: FornecedoresSelecao,
    meta: { requiresAuth: true, acesso: ["administrador", "representante"] },
  },
  {
    path: "/fornecedor/minha-conta",
    name: "fornecedor-minha-conta",
    component: MinhaContaFornecedores,
    meta: { requiresAuth: true, acesso: ["fornecedor"] },
  },
  {
    path: "/rodadas/:rodada_id/clientes",
    name: "rodadas-clientes",
    component: ClientesSelecao,
    meta: { requiresAuth: true, acesso: ["administrador", "representante"] },
  },
  {
    path: "/rodadas/:rodada_id/representantes",
    name: "rodadas-representantes",
    component: RepresentantesSelecao,
    meta: { requiresAuth: true, acesso: ["administrador", "representante"] },
  },
  {
    path: "/empresas",
    name: "empresas",
    component: Empresas,
    meta: { requiresAuth: true, acesso: ["cliente"] },
  },
  {
    path: "/empresas/cadastrar",
    name: "empresasCadastrar",
    component: EmpresasForm,
    meta: { requiresAuth: true, acesso: ["cliente"] },
  },
  {
    path: "/empresas/:id/editar",
    name: "empresasEditar",
    component: EmpresasForm,
    meta: { requiresAuth: true, acesso: ["cliente"] },
  },
  {
    path: "/representantes",
    name: "representantes",
    component: Representantes,
    meta: {
      requiresAuth: true,
      acesso: ["cliente", "administrador", "master"],
    },
  },
  {
    path: "/representantes/adicionar",
    name: "representantes-adicionar",
    component: RepresentantesForm,
    meta: { requiresAuth: true, acesso: ["administrador"] },
  },
  {
    path: "/representantes/:representante_id/editar",
    name: "representantes-editar",
    component: RepresentantesForm,
    meta: { requiresAuth: true, acesso: ["administrador", "master"] },
  },
  {
    path: "/cliente/minha-conta",
    name: "cliente-minha-conta",
    component: MinhaContaCliente,
    meta: { requiresAuth: true, acesso: ["cliente"] },
  },
  {
    path: "/remessas",
    name: "remessas",
    component: RemessasLista,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/remessas/adicionar",
    name: "remessas-adicionar",
    component: RemessasForm,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/remessas/:id/editar",
    name: "remessas-editar",
    component: RemessasForm,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/comissoes",
    name: "comissoes",
    component: ComissoesLista,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/comissoes/adicionar",
    name: "comissoes-adicionar",
    component: ComissoesForm,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/comissoes/:id/editar",
    name: "comissoes-editar",
    component: ComissoesForm,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/representante/minha-conta",
    name: "representante-minha-conta",
    component: MinhaContaRepresentante,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/faturamento",
    name: "faturamento",
    component: FaturamentoLista,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/faturamento/:id/gerar-promissorias",
    name: "gerar-promissorias",
    component: FaturamentoForm,
    meta: { requiresAuth: true, acesso: ["representante"] },
  },
  {
    path: "/produtos",
    name: "produtos",
    component: ProdutosLista,
    meta: { requiresAuth: true, acesso: ["fornecedor", "master"] },
  },
  {
    path: "/produtos/adicionar",
    name: "produtosAdicionar",
    component: ProdutosCadastro,
    meta: { requiresAuth: true, acesso: ["fornecedor", "master"] },
  },
  {
    path: "/produtos/:id/editar",
    name: "produtosEditar",
    component: ProdutosCadastro,
    meta: { requiresAuth: true, acesso: ["fornecedor", "master"] },
  },
  {
    path: "/produtos/:id/galeria",
    name: "produtosGaleria",
    component: Galeria,
    meta: { requiresAuth: true, acesso: ["fornecedor", "master"] },
  },
  /* {
    path: "/pedidos",
    name: "pedidos",
    component: PedidosLista,
    meta: { requiresAuth: true, acesso: ["fornecedor", "administrador", "representante", "cliente"] },
  }, */
  {
    path: "/pedidos",
    name: "pedidos",
    component: PedidosRedirect,
    meta: {
      requiresAuth: true,
      acesso: ["fornecedor", "representante", "cliente", "administrador"],
    },
  },
  {
    path: "/pedidos/adicionar",
    name: "pedidosForm",
    component: PedidosForm,
    meta: { requiresAuth: true, acesso: ["fornecedor"], status: "novo" },
  },
  {
    path: "/pedidos/:id/editar",
    name: "pedidoEditar",
    component: PedidosForm,
    meta: {
      requiresAuth: true,
      acesso: ["fornecedor", "representante"],
      status: "editar",
    },
  },
  {
    path: "/pedidos/:id/copiar",
    name: "pedidoCopiar",
    component: PedidosForm,
    meta: { requiresAuth: true, acesso: ["fornecedor"], status: "copiar" },
  },
  {
    path: "/ajuda",
    name: "ajuda",
    component: Videos,
    meta: { requiresAuth: true, acesso: ["fornecedor"] },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
      acesso: ["administrador", "fornecedor", "representante", "master"],
    },
  },
  {
    path: "/",
    name: "loja",
    component: Loja,
    meta: {
      requiresAuth: false,
      acesso: [
        "fornecedor",
        "representante",
        "master",
        "cliente",
        "administrador",
      ],
    },
  },
  {
    path: "/shared/:produto",
    name: "share",
    component: Loja,
    meta: {
      requiresAuth: false,
      acesso: ["fornecedor", "representante", "master", "cliente"],
    },
  },
  {
    path: "/showroom-rodada",
    name: "showroomRodada",
    component: ShowRoomRodada,
    meta: { requiresAuth: true, acesso: ["cliente"] },
  },
  // {
  //   path: "/agenda",
  //   name: "agenda",
  //   component: Agenda,
  //   meta: {
  //     requiresAuth: true,
  //     acesso: ["fornecedor", "representante", "cliente", "administrador"],
  //   },
  // },
  {
    path: "/usuarios",
    name: "usuarios",
    component: Usuarios,
    meta: { requiresAuth: true, acesso: ["master"] },
  },
  {
    path: "/mapa-stands/:rodada",
    name: "mapa",
    component: MapaStands,
    meta: { requiresAuth: false },
  },
  {
    path: "*",
    name: "any",
    redirect: "/",
    meta: { requiresAuth: false },
  },
  {
    path: "/impressoes",
    name: "impressoes",
    component: Impressoes,
    meta: { requiresAuth: true, acesso: ["fornecedor"] },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const API_TOKEN = cookies.get("api_token");
  const USER = JSON.parse(localStorage.getItem("user"));

  if (to.meta.requiresAuth || (USER && USER.id && !USER.verificado)) {
    if (
      to.name === "dashboard" &&
      !JSON.parse(localStorage.getItem("rodada"))
    ) {
      next("/");
    } else {
      if (API_TOKEN) {
        if (to.meta.acesso.includes(USER.tipo)) {
          if (USER.verificado) {
            // if (USER.tipo == "fornecedor") {
            //   if (to.name != "fornecedor-minha-conta") {
            //     if (!USER.verificacao_fornecedor) {
            //       next("/fornecedor/minha-conta");
            //     } else {
            //       next();
            //     }
            //   } else {
            //     next();
            //   }
            // } else {
            //   next();
            // }
            next();
          } else {
            if (USER.tipo == "fornecedor") {
              if (to.name != "fornecedor-minha-conta") {
                if (from.name != "fornecedor-minha-conta") {
                  next("/fornecedor/minha-conta");
                }
              } else {
                next();
              }
            } else if (USER.tipo == "representante") {
              if (to.name != "representante-minha-conta") {
                if (from.name != "representante-minha-conta") {
                  next("/representante/minha-conta");
                }
              } else {
                next();
              }
            } else if (USER.tipo == "cliente") {
              if (to.name != "cliente-minha-conta") {
                if (from.name != "cliente-minha-conta") {
                  next("/cliente/minha-conta");
                }
              } else {
                next();
              }
            }
          }
        } else {
          next(from.path);
        }
      } else {
        next("/");
      }
    }
  } else {
    next();
  }
});

export default router;
